<template>
<v-form ref="form" v-model="valid">
  <v-container fluid>
    <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>

    </v-app-bar>
  </nav>

    <v-card-title>General</v-card-title>
    <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>RYB Console S/N</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="serialNumber"
            item-value="_id"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="rybSn"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>RYB Console Label</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="rybConsole"> </v-text-field>
        </v-col>
        <v-col cols="2">
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="boardName"> </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>Smart Meter Reading Number Now</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field type="Number" v-model="meter"> </v-text-field>
        </v-col>
        <v-col cols="2">
        </v-col>
      </v-row>
   </v-card>

    <v-card-title>Phase R</v-card-title>
    <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>Phase R Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="rybSnR"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Phase R Console Label</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="rybConsoleR"> </v-text-field>
        </v-col>
        <v-col cols="2">
        </v-col>
      </v-row>
   </v-card>

   <v-card-title>Phase Y</v-card-title>
    <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Y Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="rybSnY"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Phase Y Console Label</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="rybConsoleY"> </v-text-field>
        </v-col>
        <v-col cols="2">
        </v-col>
      </v-row>
   </v-card>

    <v-card-title>Phase B</v-card-title>
    <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>Phase B Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="rybSnB"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Phase B Console Label</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="rybConsoleB"> </v-text-field>
        </v-col>
        <v-col cols="2">
        </v-col>
      </v-row>
   </v-card>

     <v-btn fixed dark fab bottom right color="blue" @click="saveItem()">
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
  </v-container>
</v-form>
</template>


<script>
import axios from "axios";
import router from "../../router";

export default {
  data() {
    return {
    items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Settings',
          disabled: true,
          href: '',
        },
        {
          text: 'Single Phase',
          disabled: false,
          href: '/single-phase',
        },
        {
          text: 'Add',
          disabled: true,
          href: '',
        }
      ],
    rybSn: "",
    rybConsole: "",
    boardName: "",
    meter: null,
    rybSnR: "",
    rybConsoleR: "",
    rybSnY: "",
    rybConsoleY: "",
    rybSnB: "",
    rybConsoleB: "",

    valid: true,
    serialNumber: [], 
    showDeleteDialog: false,
    };
  },
  created(){
      this.loadsSerialNumber();
  },
  methods: {
    loadsSerialNumber: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/serial-number-available";
    axios.get(apiURL).then(res => {
    this.serialNumber = res.data;
    }).catch(error => {
        console.log(error)
    });
  },
    async saveItem() {
      if (this.$refs.form.validate()) {
      let apiURL = process.env.VUE_APP_API + "/api/create-single-Phase";
      axios
        .post(
      apiURL,
          {
    rybSn: this.rybSn,
    rybConsole: this.rybConsole,
    boardName: this.boardName,
    meter: this.meter,
    rybSnR: this.rybSnR,
    rybConsoleR: this.rybConsoleR,
    rybSnY: this.rybSnY,
    rybConsoleY: this.rybConsoleY,
    rybSnB: this.rybSnB,
    rybConsoleB: this.rybConsoleB,

    modifiedBy: this.$keycloak.tokenParsed.given_name
          });
    }
     router.go(-1);
      }
    }
  };
</script>